import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { dailyThoughts } from '../data/dailyThoughts';
import SEO from '../components/SEO';
import { useTheme } from '../context/ThemeContext';

function Daily() {
  const { isDark, toggleTheme } = useTheme();
  
  const bgColor = isDark ? '#0F0F0F' : '#FAF9F6';
  const textColor = isDark ? 'text-white' : 'text-black';
  const textMuted = isDark ? 'text-white/60' : 'text-black/60';
  const textVerySubtle = isDark ? 'text-white/30' : 'text-black/30';
  const borderColor = isDark ? 'border-white/5' : 'border-black/5';
  const linkHover = isDark ? 'hover:text-white/80' : 'hover:text-black/80';

  return (
    <div className={`min-h-screen ${textColor} transition-colors duration-300`} style={{ fontFamily: '"Noto Sans", -apple-system, sans-serif', backgroundColor: bgColor }}>
      <SEO />
      <div className="max-w-[60ch] mx-auto px-6 py-20">
        <motion.header
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="mb-24 flex items-start justify-between"
        >
          <div>
            <Link to="/" className={`${textVerySubtle} ${linkHover} text-xs mb-8 inline-block transition-colors`}>
              ← back
            </Link>
            <h1 className={`text-5xl font-light tracking-tight mb-4 ${textColor}`} style={{ fontFeatureSettings: '"liga" 1, "calt" 1' }}>
              Daily
            </h1>
            <p className={`${textMuted} text-lg font-light leading-[1.7]`} style={{ fontFeatureSettings: '"liga" 1, "calt" 1' }}>
              Raw thoughts and late night sessions
            </p>
          </div>
          <button
            onClick={toggleTheme}
            className={`w-6 h-6 rounded-full ${isDark ? 'bg-white/3 hover:bg-white/6' : 'bg-black/3 hover:bg-black/6'} transition-all duration-200 flex items-center justify-center mt-2`}
            aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
          >
            <div className={`w-2 h-2 rounded-full ${isDark ? 'bg-white/30' : 'bg-black/30'}`}></div>
          </button>
        </motion.header>

        <div className="space-y-12">
          {dailyThoughts.map((thought, idx) => (
            <motion.div
              key={thought.id}
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: 0.1 + idx * 0.05 }}
              className={`border-b ${borderColor} pb-8`}
            >
              <p className={`text-base leading-[1.7] mb-4 ${textMuted}`} style={{ fontFeatureSettings: '"liga" 1, "calt" 1' }}>
                {thought.thought}
              </p>
              <div className={`text-xs ${textVerySubtle} font-mono`} style={{ fontFeatureSettings: '"onum" 1' }}>
                {thought.time} · {thought.date}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Daily;
